import React, { Component } from "react";
import { connect } from "react-redux";
import { withWrapper } from "create-react-server/wrapper";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import rubric from "modules/rubric";
import "./Rubric.css";

class Rubric extends Component {
  constructor(props) {
    super(props);
    props.getRubric(props.match.params.id);
  }

  componentWillMount() {
    this.props.clearRubric();
  }

  render() {
    return (
      <div className="content rubric">
        <div
          className="information-table margin-normal"
          style={{ marginBottom: "40px" }}
        >
          <div>
            <span className="underline-title underline-title--no_underline">
              {this.props.match.params.id === "afishanewyearraus"
                ? "Новогодняя интерактивная программа в библиотеках"
                : this.props.match.params.id === "writers"
                ? "Встречи с писателями"
                : this.props.match.params.id === "afishanewyear2018"
                ? "Новогодние представления в библиотеках"
                : "Афиша"}
            </span>
          </div>
          {this.props.match.params.id === "afisha1" ? (
            <div style={{ width: "70%" }}>
              Еженедельные подборки лучших событий в библиотеках Москвы. Лекции,
              выставки, кинопоказы, экскурсии
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="imagae-table">
          {this.props.rubric.map((article, index) => {
            if (!article.cover) return "";
            if (!article.url_external) {
              return (
                <Link
                  key={index}
                  className="imagae-table-cell"
                  to={{ pathname: `/article/${article.url}` }}
                >
                  <img
                    className="image"
                    src={`${process.env.REACT_APP_IMG_SERVER}/img/${article.cover}/mobile`}
                    alt=""
                  />
                  <div
                    className="article-title"
                    dangerouslySetInnerHTML={{ __html: article.title }}
                  />
                  <div className="icon-arrow" />
                </Link>
              );
            } else {
              return (
                <a
                  key={index}
                  className="imagae-table-cell"
                  href={article.url_external}
                >
                  <img
                    className="image"
                    src={`${process.env.REACT_APP_IMG_SERVER}/img/${article.cover}/mobile`}
                    alt=""
                  />
                  <div
                    className="article-title"
                    dangerouslySetInnerHTML={{ __html: article.title }}
                  />
                </a>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rubric: state.rubric.rubric
});

const mapDispatchToProps = dispatch => ({
  getRubric: bindActionCreators(rubric.actions.getRubric, dispatch),
  clearRubric: bindActionCreators(rubric.actions.clearRubric, dispatch)
});

export default withWrapper(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Rubric)
);



// WEBPACK FOOTER //
// ./src/components/Rubric/Rubric.js